import React from "react";
import "./JobItem.css";

export default function JobItem({ title, active, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`job-item-btn mb-2 ${active ? "active" : ""}`}
      aria-pressed={active}
    >
      <span className="job-item-title">{title}</span>
      <span className="job-item-symbol" aria-hidden>
        {active ? "—" : "+"}
      </span>
    </button>
  );
}
